
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/logos",
      function () {
        return require("private-next-pages/logos.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/logos"])
      });
    }
  